<template lang="pug">
//- b-card#changePwd(
//-   ref="changePwd"
//-   :header="$t('ui.change_password')"
//-   ).inner.icon-password
.card.card-glass
  .card-header.p-2
    i.fa.fa-key
    span #[b {{ $t('ui.change_password') }}]
  .card-body.p-3
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.old_password')").mb-3
        DebounceInput(
          size="sm"
          autofocus
          type="password"
          :dirty="$v.userPwdOld.$dirty"
          :error="$v.userPwdOld.$error"
          v-model.trim.lazy="$v.userPwdOld.$model"
          :disabled="loading"
          autocomplete="section-red current-password"
        )
        ValidateResult(:value="$v.userPwdOld" :name="$t('ui.old_password')")
      b-form-group(:label="$t('ui.new_password')").mb-1
        DebounceInput(
          size="sm"
          type="password"
          :dirty="$v.userPwd.$dirty"
          :error="$v.userPwd.$error"
          v-model.trim.lazy="$v.userPwd.$model"
          :disabled="loading"
          autocomplete="section-red new-password"
        )
        ValidateResult(:value="$v.userPwd" :name="$t('ui.new_password')")
      b-form-group(:label="$t('ui.confirm_password')").mb-1
        DebounceInput(
          size="sm"
          type="password"
          :dirty="$v.userPwdConfirm.$dirty"
          :error="$v.userPwdConfirm.$error"
          v-model.trim.lazy="$v.userPwdConfirm.$model"
          :disabled="loading"
          autocomplete="section-red new-password"
        )
        ValidateResult(:value="$v.userPwdConfirm" :name="$t('ui.confirm_password')", :name2="$t('ui.new_password')")
    b-alert.m-0.text-center.animated.flash(:show="!feedback.success" variant="danger") {{ $t("error." + feedback.status) }}
  .card-footer.px-3.py-2.text-right
    SubmitButton.btn-brand(:loading="loading" icon="fa fa-times" :text="$t('ui.clear')" type="button" @click="emptyPwd" size="md" variant="secondary").mr-2
    SubmitButton.btn-brand(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" type="button" @click="changePassword" size="md" variant="danger" highlight=true)
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import { required, minLength, maxLength, sameAs, helpers } from "vuelidate/lib/validators";
import DebounceInput from "@/library/DebounceInput";

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  data() {
    return {
      userPwdOld: "",
      userPwd: "",
      userPwdConfirm: "",
      pwdCollapse: false,
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  validations: {
    userPwdOld: {
      required,
      minLength: minLength(6),
      maxLength: maxLength(50)
    },
    userPwd: {
      required,
      valid: function(value) {
        return this.$helpers.passwordFormat(value);
      },
      minLength: minLength(8),
      maxLength: maxLength(50)
    },
    userPwdConfirm: {
      required,
      sameAs: sameAs("userPwd")
    }
  },
  methods: {
    togglePwdCollapse() {
      this.pwdCollapse = !this.pwdCollapse;
    },
    changePassword() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.changePwdUserUrl();

        var json = {
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.setting,
          user_id: this.$store.getters.username,
          password: this.userPwd,
          oldpassword: this.userPwdOld
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }

                this.feedback.status = response.data.statusdesc;

                if (this.feedback.success == true) {
                  this.emptyPwd();
                  this.$helpers.showDialog(this.$t("ui.change_password"), this.$t("message.successful_change_password"), "success");
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
            // console.log(this.feedback, response);
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            // console.log(this.feedback, response);
          }
        );
      }
    },
    emptyPwd() {
      this.userPwdOld = "";
      this.userPwd = "";
      this.userPwdConfirm = "";

      this.$nextTick(() => {
        this.$v.$reset();
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
